import React from 'react'
import ReactDOM from 'react-dom/client'
import './firebaseAppCheckBootstrap'
import { migrateStorage } from './utils/storage';

// Run storage migration before any other setup (like i18n, router, etc)
migrateStorage();

import { AppRouter } from './AppRouter'
import './index.css'
import './i18n'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
)
